import devnet from "./devnet";
import staging from "./staging";
import production from "./production";

const config =
  {
    devnet,
    staging,
    production,
  }[import.meta.env.VITE_ALLSTAKE_ENV || "devnet"] || "devnet";

const filteredUnsupportedTokens = config.restakingTokens.filter((token) =>
  config.supportNetworks.includes(token.chain),
);
export default {
  ...config,
  restakingTokens: filteredUnsupportedTokens,
};
